var map = {
	"./ALB.json": [
		3866,
		866
	],
	"./AUT.json": [
		6657,
		657
	],
	"./AZE.json": [
		5950,
		950
	],
	"./BEL.json": [
		5984,
		984
	],
	"./BGR.json": [
		2410,
		410
	],
	"./BIH.json": [
		7861,
		861
	],
	"./CAN.json": [
		6471,
		471
	],
	"./CYP.json": [
		7839,
		839
	],
	"./CZE.json": [
		5659,
		659
	],
	"./DAN.json": [
		5263,
		693
	],
	"./DEU.json": [
		3564,
		564
	],
	"./ENG.json": [
		2829,
		829
	],
	"./EST.json": [
		2874,
		874
	],
	"./FIN.json": [
		5683,
		683
	],
	"./FRA.json": [
		1640,
		640
	],
	"./GRC.json": [
		9020,
		20
	],
	"./HRV.json": [
		598,
		598
	],
	"./HUN.json": [
		9163,
		163
	],
	"./IDN.json": [
		5491,
		491
	],
	"./ISL.json": [
		8017,
		17
	],
	"./ITA.json": [
		3568,
		568
	],
	"./KAZ.json": [
		4383,
		383
	],
	"./LAV.json": [
		7369,
		369
	],
	"./LTU.json": [
		7372,
		372
	],
	"./LVA.json": [
		1061,
		61
	],
	"./MLT.json": [
		4263,
		263
	],
	"./NLD.json": [
		7641,
		641
	],
	"./NOR.json": [
		2773,
		773
	],
	"./POL.json": [
		3314,
		314
	],
	"./PRT.json": [
		656,
		656
	],
	"./ROU.json": [
		3743,
		743
	],
	"./RUS.json": [
		9364,
		364
	],
	"./SPA.json": [
		8490,
		490
	],
	"./SRB.json": [
		679,
		679
	],
	"./SRP.json": [
		6175,
		175
	],
	"./SVK.json": [
		5129,
		129
	],
	"./SVN.json": [
		6032,
		32
	],
	"./SWE.json": [
		4294,
		294
	],
	"./THA.json": [
		5440,
		440
	],
	"./TUR.json": [
		3703,
		703
	],
	"./UKR.json": [
		8734,
		734
	],
	"./VIE.json": [
		6004,
		4
	],
	"./ZAF.json": [
		9889,
		889
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5407;
module.exports = webpackAsyncContext;